import { useNavigate } from "react-router-dom";
import ManageUsersService from "../../services/UserManagementService";
import InvelpsAuth from "../Login/InvelpsAuth";

export default function InvelpsSignUp({
  googleAuthUrl = "/auth/google",
  linkedinAuthUrl = "/auth/linkedin",
}) {
  const navigate = useNavigate();
  const restClient = new ManageUsersService();

  const signupSubmit = async ({ firstName, lastName, email, password }) => {
    await restClient.signUpUser({
      firstname: firstName,
      lastname: lastName,
      email,
      password,
    });
    setTimeout(() => navigate("/login"), 1200);
  };

  return (
    <InvelpsAuth
      initialPage="signup"
      googleAuthUrl={googleAuthUrl}
      linkedinAuthUrl={linkedinAuthUrl}
      signupSubmit={signupSubmit}
      onGoLogin={() => navigate("/login")}
      onSuccess={() => navigate("/login")}
    />
  );
}
